
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chapters/[slug]",
      function () {
        return require("private-next-pages/chapters/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chapters/[slug]"])
      });
    }
  